import * as TYPES from './constants';
import {
  requestOccupationList,
  receiveOccupationList,
  handleOccupationListError,
} from './actions';
import {API} from 'config/employer.config';
import {JSON_HEADER, JWT_HEADER} from 'config/srm.config';

const initialState = {
  data: null,
  error: null,
  request: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_OCCUPATIONS_LIST:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_OCCUPATIONS_LIST:
      return {
        ...state,
        data: action.payload,
        request: false,
      };
    case TYPES.OCCUPATIONS_LIST_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.OCCUPATIONS_LIST_CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const fetchOccupationsList = () => (dispatch, getState) => {
  const {
    auth: {access: {token = null} = {}},
  } = getState();
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
    cache: 'default',
  };
  dispatch(requestOccupationList());
  try {
    return fetch(`${API.administration.occupation}`, config)
      .then(response => response.json())
      .then(json => {
        dispatch(receiveOccupationList(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleOccupationListError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleOccupationListError(err));
  }
};
